import React, { useState, useEffect } from 'react';
import { Layout as AntLayout, Menu, Button, Drawer } from 'antd';
import { CarOutlined, BarChartOutlined, LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import brand from '../lib/brand';

const { Sider, Content, Header } = AntLayout;

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const menuItems = [
    { key: '/', icon: <CarOutlined />, label: 'Хүргэлтүүд' },
    { key: '/report', icon: <BarChartOutlined />, label: 'Тайлан' },
  ];

  const onMenuClick = ({ key }) => {
    navigate(key);
    setDrawerOpen(false);
  };

  const sideContent = (
    <>
      <div style={{ padding: '16px', textAlign: 'center', color: '#fff', fontSize: 18, fontWeight: 'bold' }}>
        {brand.name}
      </div>
      <Menu theme="dark" mode="inline" selectedKeys={[location.pathname]}
        items={menuItems} onClick={onMenuClick} />
      <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
        <Menu theme="dark" mode="inline" selectable={false}
          items={[{ key: 'logout', icon: <LogoutOutlined />, label: 'Гарах', onClick: () => { logout(); navigate('/login'); } }]}
        />
      </div>
    </>
  );

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      {!isMobile && (
        <Sider breakpoint="lg" collapsedWidth="0">{sideContent}</Sider>
      )}
      {isMobile && (
        <Drawer placement="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}
          width={240} bodyStyle={{ padding: 0, background: '#001529' }} closable={false}>
          {sideContent}
        </Drawer>
      )}
      <AntLayout>
        <Header style={{ background: '#fff', padding: '0 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {isMobile ? (
            <Button type="text" icon={<MenuOutlined />} onClick={() => setDrawerOpen(true)} />
          ) : <div />}
          <span>{user?.name}</span>
        </Header>
        <Content style={{ margin: isMobile ? 8 : 24 }}>
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
